module.exports = __webpack_public_path__ + "img/C07TechDrinkofAegir_ua.006cffef.webp";